import React from "react";

import type { JSX, ReactNode } from "react";

interface DataTableCountCellProps {
  count: number;
  icon?: ReactNode;
}

function DataTableCountCell({
  count,
  icon,
}: DataTableCountCellProps): JSX.Element {
  return (
    <span className="[&_svg]:text-muted-foreground inline-flex items-center gap-1.5 align-middle [&_svg]:size-4">
      {icon}
      {count}
    </span>
  );
}

export default DataTableCountCell;
